'use es6';

import { withTheme } from 'foundations-theming/utils';
import { Component } from 'react';
import PropTypes from 'prop-types';
import UIFullScreen from 'UIComponents/dialog/UIFullScreen';
import UIEditorPage from 'UIComponents/page/UIEditorPage';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { APP_STATUS } from 'ContentEditorUI/redux/constants';
import { isInOnboardingSession } from 'onboarding-tours/util/bannerFrame';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FullScreenEditorWrapperWithoutTheme extends Component {
  renderGlobalLoadingOverlayIfNeeded() {
    const {
      appStatus
    } = this.props;
    return appStatus === APP_STATUS.LOADING ? /*#__PURE__*/_jsx(UILoadingOverlay, {
      className: "selenium--editor-loading-overlay",
      "data-test-id": "editor-global-loader-overlay"
    }) : null;
  }
  render() {
    const {
      children,
      className,
      headerComponent,
      tabBarComponent
    } = this.props;
    const onboardingBannerClassname = isInOnboardingSession() ? 'has-onboarding-banner' : '';
    return /*#__PURE__*/_jsx(UIFullScreen, {
      children: /*#__PURE__*/_jsxs("div", {
        className: `fullscreen-editor-wrapper ${className} ${onboardingBannerClassname}`,
        children: [/*#__PURE__*/_jsx(UIEditorPage, {
          id: "editor-page",
          mainSectionFlush: true,
          hasScrolling: false,
          headerComponent: headerComponent,
          mainBackgroundColor: this.props.theme.color['do-not-use-olaf'],
          tabs: tabBarComponent,
          children: children
        }), this.renderGlobalLoadingOverlayIfNeeded()]
      })
    });
  }
}
FullScreenEditorWrapperWithoutTheme.propTypes = {
  appStatus: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  headerComponent: PropTypes.node.isRequired,
  tabBarComponent: PropTypes.node.isRequired
};
const FullScreenEditorWrapper = withTheme(FullScreenEditorWrapperWithoutTheme);
export default FullScreenEditorWrapper;